import { Component, Input, OnInit, ViewChild, ElementRef, NgZone, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { FormControl, FormGroup, FormArray, Validators, FormBuilder } from '@angular/forms';

// import 'rxjs/Rx' ;
import { TranslateService } from '@ngx-translate/core';
import { ProjectmanagementService } from '../../../../../projects/projectmanagement/src/app/service/projectmanagement.service';
import { SchoolManagementService } from '../service/schoolmanagement.service';
import { UserManagementService } from '../../../../tools/src/service/user.management.service';
// import { CtlNewModal} from '../../directive/ModalNew/CtlNewModal.directive';
import { CtlNewUserForm } from '../../../../../projects/tools/src/lib/forms/newuser/CtlNewUserForm';
import { CtlSchoolForm } from '../forms/school/CtlSchoolForm';
import { AddGradeClassComponent } from '../forms/schoolGradeClass/ctl.school.gradeclass.component';
import { AddGradeSubjectComponent } from '../forms/schoolGradeSubject/ctl.school.gradesubject.component';
import { Project, School, SchoolCategory, Region, Subject, Partner, Country, User, Role, Grade, Class } from '../../../../projectmanagement/src/app/model/project.model';
import * as projectforms from '../../../../projectmanagement/src/app/forms/projectmanagement.form';
import { ToolsService } from '../../../../tools/src/lib/tools.service';
import { TabGroup } from '@eds/vanilla';
import { Dialog } from '@eds/vanilla';
import { Dropdown } from '@eds/vanilla';
/* error handler */
import { MyErrorHandler } from '../../../../projectmanagement/src/app/errorhandler/errorhandler';

import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-schooloverview',
  templateUrl: './schooloverview.component.html',
  styleUrls: ['./schooloverview.component.css'],
  providers: [ProjectmanagementService, SchoolManagementService, UserManagementService, DatePipe]
})
export class SchooloverviewComponent implements OnInit, AfterViewInit {
  loggedInUser: any;
  @ViewChild('overviewTabs') overviewTabs;
  // @ViewChild(CtlNewModal)
  // private newModal: CtlNewModal;
  // @ViewChild(AddGradeClassComponent)
  //   private formGradeClass: AddGradeClassComponent;
  @ViewChild(AddGradeSubjectComponent)
  private formGradeSubject: AddGradeSubjectComponent;
  @ViewChild(CtlNewUserForm)
  private userForm: CtlNewUserForm;

  userFormGroup: FormGroup;
  fgClassSubject: FormGroup;
  fgAssignTeacher: FormGroup;

  @ViewChild(CtlSchoolForm)
  private schoolForm: CtlSchoolForm;
  curView = 'read';
  loaded = false;
  project_id: string;
  school_id: string;
  schoolShortName: string;
  schoolName: string;
  filterList: any;
  currentView = 'add';
  schoolCategoryList: SchoolCategory[];
  countryList: Country[];
  regionList: Region[];
  newPassword = '';
  projectData;
  schoolData;
  curUserData;
  userListData = [];
  keySubjectListDropdownForTeacher = [];
  roleListData;
  myrole;
  gradeSubjectList;
  gradeList: any[] = [];
  gradeListFilter: any[];
  classListStudFilter = [];
  gradeListStudFilter: any[];
  classList = [];
  subjectList = [];
  teacherList = [];
  studentList = [];
  studentCount = 0;
  teacherCount = 0;
  studentCountTxt: string;
  teacherCountTxt: string;
  pageType = '';
  adminCount = 0;
  adminList;
  btnTextSend = '';
  btnTextEdit = '';
  btnStatusSend = false;
  btnSendStatus = false;
  btnStatusEdit = false;
  btnStatusEditSchool = false;
  titleMessage; // confirm message for alert modal
  subTitleMessage; // confirm message for alert modal
  detailMessage; // confirm message for alert modal
  confirmFor;
  userUpdated = false;
  assignmentList: any[];

  curTeacher: string;
  curGradeData: any;
  selectedSubjectList: string;
  selectedClassList: string;
  classSubjectTitle: string;
  classSubjectInfo: string;
  curClass: any;
  saveButtonStatus: boolean;
  isSubjectRemoved = true;
  currentRole: string;
  user_id: string;
  titleModal = 'Add new teacher';
  isHeader = false;
  teacherModalType = 'read';
  btnStatusAdd = false;
  error = '';
  message = '';

  titleAssignTeacherModal: string;
  subjectTeacherAssigned: any;
  projGradeList: any[];
  gterm: Grade;
  cterm = '';
  sterm = '';
  term1 = '';
  term2 = '';
  term3 = '';
  ksub: Subject;

  // userlist
  uname = '';
  urole = '';
  upart = '';
  ugrade: Grade;
  uclass = '';
  usubject = '';
  ustatus: any;
  isSchoolAdmin = false;
  statusFilter = [
    { name: 'Active', state: true, req_stat: 'active' },
    { name: 'Archived', state: false, req_stat: 'archived' },
    { name: 'Access request', state: false, req_stat: 'accessrequest' }
  ];


  firstteacher = '';
  // grade/class list
  gname = '';
  gclass = '';
  gsubject = '';
  edited = true;

  xlssample: any;
  removedClassArr = [];
  removedClassName = [];
  removedSubjectArr = [];
  detailMessage1 = '';
  detailMessage2 = '';
  listMessage: any;
  listMessage1: any;
  subject_ids = [];
  hasSubjects = false;

  propertyName: string;
  propertyNameSorting: string;
  orderType = true;
  isSorted = false;
  sortedClass: string;
  gradeSelectConfig: any;
  subjectSelectConfig: any;
  classSelectConfig: any;
  statusSelectConfig: any;


  schoolIconColor = {
    stringToColorHash: {},
    nextVeryDifferntColorIdx: 63,
    veryDifferentColors: [
      '#000000', '#00FF00', '#0000FF', '#FF0000', '#01FFFE', '#FFA6FE',
      '#FFDB66', '#006401', '#010067', '#95003A', '#007DB5', '#FF00F6',
      '#FFEEE8', '#774D00', '#90FB92', '#0076FF', '#D5FF00', '#FF937E',
      '#6A826C', '#FF029D', '#FE8900', '#7A4782', '#7E2DD2', '#85A900',
      '#FF0056', '#A42400', '#00AE7E', '#683D3B', '#BDC6FF', '#263400',
      '#BDD393', '#00B917', '#9E008E', '#001544', '#C28C9F', '#FF74A3',
      '#01D0FF', '#004754', '#E56FFE', '#788231', '#0E4CA1', '#91D0CB',
      '#BE9970', '#968AE8', '#BB8800', '#43002C', '#DEFF74', '#00FFC6',
      '#FFE502', '#620E00', '#008F9C', '#98FF52', '#7544B1', '#B500FF',
      '#00FF78', '#FF6E41', '#005F39', '#6B6882', '#5FAD4E', '#A75740',
      '#A5FFD2', '#FFB167', '#009BFF', '#E85EBE']
  };

  btnTextAdd = '';
  btnTextCancel = '';
  btnTextDeny = '';
  btnTextAllow = '';
  wizardSteps = [
    'Add school classes',
    'Assign subjects',
    'Add students & teachers',
    'Assign teachers'
  ];

  selectedTab: string;
  dpFlag: boolean;

  page = 1;
  noOfItems = 18;

  pageTeacher = 1;
  noOfItemsTeacher = 18;

  studentsTabLoaded = false;
  textDir: any;
  private clickTimeout = null;
  isImportClicked = false;
  isUserSaveBtnClicked = false;

  constructor(public datepipe: DatePipe,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private projectService: ProjectmanagementService,
    private schoolService: SchoolManagementService,
    private userService: UserManagementService,
    private util: ToolsService) {

    this.textDir = sessionStorage.getItem('textDir');

  }

  ngOnInit(): void {
    this.dpFlag = false;
    this.saveButtonStatus = true;
    this.selectedTab = '';
    this.isImportClicked = false;
    this.isUserSaveBtnClicked = false;
    if (window.localStorage.getItem('loginInfoObj') == null) {
      console.log('token info missing');
      this.router.navigate(['/login']);
    }
    this.translate.get('All grades').subscribe((translated: string) => {
      this.gradeSelectConfig = {
        placeholder: translated,
        displayKey: 'name',
        search: false,
        height: '150px',
        customComparator: ((a, b) => {
          const nameA = a.year.number; // ignore upper and lowercase
          const nameB = b.year.number; // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        })
      };
      this.subjectSelectConfig = {
        placeholder: this.translate.instant('All key subjects'),
        displayKey: 'name',
        search: false,
        height: '150px'
      };
      this.classSelectConfig = {
        placeholder: this.translate.instant('All classes'),
        displayKey: 'name',
        search: false,
        height: '150px'
      };
      this.statusSelectConfig = {
        placeholder: this.translate.instant('All status'),
        displayKey: 'name',
        search: false,
        height: '150px'
      };
    })
    this.fgClassSubject = this.fb.group({
      classes: this.fb.array([]),
      subjects: ['']
    });
    this.fgAssignTeacher = this.fb.group({
      class_id: [''],
      subjectteacher: this.fb.array([this.patchSubjectTeacher('', '', '')])
    });
    this.userFormGroup = this.fb.group(projectforms.formUser);
    const userData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    if (userData) {
      this.loggedInUser = userData;
    }
    this.getCountryList();
    this.getSchoolCategoryList();
    this.getRoleList();

    this.route.params.subscribe(params => {
      this.school_id = params['school_id'];
      if (params['project_id']) {
        this.project_id = params['project_id'];
      }
      if (!this.school_id) {
        this.school_id = userData.school._id;
      }
      if (!this.project_id) {
        this.project_id = userData.project._id;
      }
      this.tabInit();
      this.getProjectData(this.project_id);
      this.getSchoolDetails(this.school_id, true);
      this.getUserList('schoolId', this.school_id);
      this.getRegionList(this.project_id);
      this.getGradeList(this.school_id);
      this.showAddNewBtns(1);
    });
    this.userUpdated = false;
    if (window.localStorage.getItem('schoolSetupSuccess')) {
      this.titleMessage = 'Setup Complete';
      this.detailMessage = 'Great work! You have added Classes, \
      Subjects, Students and Teachers, and you have assigned Teachers to Classes.';

      window.localStorage.removeItem('schoolSetupSuccess');
      this.openDialogModal('successModal');
    }
  }
  ngAfterViewInit() {
    this.tabInit();
  }
  sortByDefault(propertyName) {
    this.isSorted = true;
    this.sortedClass = '';
    this.propertyName = propertyName;
    this.orderType = true;
    this.propertyNameSorting = propertyName;
  }
  sortBy(propertyName) {
    this.isSorted = true;
    this.sortedClass = '';
    this.propertyName = propertyName;
    if (propertyName !== null && this.propertyName === propertyName) {
      if (this.orderType === true) {
        this.orderType = false;
        this.propertyNameSorting = propertyName;
        this.sortedClass = 'asc';
      } else {
        this.orderType = true;
        this.propertyNameSorting = '-' + propertyName;
        this.sortedClass = 'desc';
      }
    }
  }

  tabInit() {
    const tabs = document.querySelectorAll('.tabs');
    if (tabs) {
      Array.from(tabs).forEach(tabGroup1 => {
        const tabGroup = new TabGroup(tabGroup1 as HTMLElement);
        tabGroup.init();
      });
    }
  }

  dropdownInit() {
    const dropdowns = document.querySelectorAll('.dropdown');
    if (dropdowns) {
      Array.from(dropdowns).forEach((dropdown1) => {
        const dropdown = new Dropdown(dropdown1 as HTMLElement);
        dropdown.init();
      });
    }
  }

  userTab(data) {
    this.myrole = data;
    setTimeout(() => { this.dropdownInit(); }, 300);
    this.term1 = '';
    this.term2 = '';
    this.term3 = '';
    // this.gterm = '';
    this.cterm = '';
    this.sterm = '';

    // userlist
    this.uname = '';
    this.urole = '';
    this.upart = '';
    // this.ugrade = '';
    this.uclass = '';
    this.usubject = '';
    // this.ustatus = {name: '', state: '', req_stat: ''};
    this.btnSendStatus = false;
  }

  applyFilter(key, data) {
    console.log(key + " === " + data);
    if (key === 'gname') {
      if (data && data.value) {
        this.gname = data.value.name;
      } else {
        this.gname = '';
      }
    }
    if (key === 'ksub') {
      if (data && data.value) {
        this.ksub = { _id: data.value._id, name: data.value.name };
      } else {
        this.ksub = { _id: '', name: '' };
      }
    }
    if (key === 'gclass') {
      if (data && data.value) {
        this.gclass = data.value;
      } else {
        this.gclass = '';
      }
    }
    if (key === 'gsubject') {
      if (data && data.value) {
        this.gsubject = data.value.name;
      } else {
        this.gsubject = '';
      }
    }

    if (key === 'uname') {
      if (data && data.value) {
        this.uname = data.value.name;
      } else {
        this.uname = '';
      }
    }
    if (key === 'uclass') {
      if (data && data.value) {
        this.uclass = data.value;
      } else {
        this.uclass = '';
      }
    }
    if (key === 'ustatus') {
      /*  if (data && data.value) {
        if(data.value.active){
          this.ustatus = "active";
        }
        if(!data.value.active || data.value.active == undefined){
          this.ustatus = "archived";
        }
        if( data.value.request_status && data.value.request_status =="new"){
          this.ustatus = "accessrequest";
        }
        
       } else {
         this.ustatus = "";
       } */
    }
    if (key === 'ugrade') {
      if (data && data.value) {
        this.ugrade.name = data.value.name;
      } else {
        this.ugrade.name = '';
      }
    }
    if (key === 'usubject') {
      if (data && data.value) {
        this.usubject = data.value.name;
      } else {
        this.usubject = '';
      }
    }
  }

  setupYourSchool() {
    if (
      this.loggedInUser.role.name === 'GeneralAdmin' ||
      this.loggedInUser.role.name === 'ProjectAdmin') {
      this.router.navigate(['/projectmanagement', this.project_id, this.school_id, 'setup']);
    } else if (this.loggedInUser.role.name === 'SchoolAdmin') {
      this.router.navigate(['/schoolmanagement', 'setup']);
    }
  }

  getProjectData(projectId: string) {
    this.projectService.detail(this.project_id).subscribe(
      (response) => {
        this.projectData = response[0];
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        // console.log('COMPLETED');
      }
    );
  }

  getSchoolDetails(school_id, firsttime) {
    this.schoolService.detail(school_id).subscribe(
      (response) => {
        this.schoolData = response;
        this.schoolShortName = this.tabHeadingInitial(this.schoolData.name);
        this.schoolName = this.schoolData.name;
        this.teacherCount = this.schoolData.teacherCount;
        this.studentCount = this.schoolData.studentCount;
        this.subTitleMessage = this.schoolData.name;
      },
      (err) => {
        console.log('ERROR: ' + err);
      },
      () => {
        if (!firsttime) {
          if (this.schoolData.active === true) {
            this.titleMessage = this.translate.instant('School Enabled');
          } else {
            this.titleMessage = this.translate.instant('School Archived');
          }
          this.detailMessage = '';
          this.openDialogModal('successModal');
        }
      }
    );
  }

  getGradeList(school_id) {
    this.schoolService.listClass(school_id).subscribe(
      (response) => {
        this.gradeList = new Array();
        this.classList = new Array();
        this.gradeListFilter = new Array();
        const classList = response;
        this.assignmentList = classList.slice();
        for (const assignmentA of this.assignmentList) {
          for (const subjectTeacherA of assignmentA.subjectteacher) {
            if (subjectTeacherA.firstteacher !== undefined) {
              subjectTeacherA.firstteacher.fullname = subjectTeacherA.firstteacher.first_name + ' ' + subjectTeacherA.firstteacher.last_name;
            }
            if (subjectTeacherA.secondteacher !== undefined) {
              subjectTeacherA.secondteacher.fullname = subjectTeacherA.secondteacher.first_name + ' ' + subjectTeacherA.secondteacher.last_name;
            }
          }
        }

        const tmpGradeList = {};

        for (const myclass of classList) {
          if (myclass.grade) {
            tmpGradeList[myclass.grade.name] = myclass.grade;
          }
        }

        this.gradeList = Object.keys(tmpGradeList).map(key => tmpGradeList[key]);
        // console.log('Parent gradeList 2' + JSON.stringify(this.gradeList));

        const tempSub = []
        let i = 0;
        let classes = '';
        for (const grade of this.gradeList) {
          let subjects = '';
          this.gradeList[i].objclasses = [];
          this.gradeList[i].objsubjects = [];
          this.gradeList[i].studentCount = 0;
          this.gradeList[i].teacherCount = 0;
          var teacherArr = [];

          classes = '';
          classList.forEach(item => {

            if (item.grade) {
              if (grade.name === item.grade.name) {
                // add student and teacher count

                if (item.subjectteacher[0].firstteacher) {
                  item.subjectteacher.forEach(teacher => {
                    if (typeof teacher.firstteacher !== 'undefined' && teacherArr.indexOf(teacher.firstteacher._id) == -1) {
                      teacherArr.push(teacher.firstteacher._id);
                    }
                  });
                }

                this.gradeList[i].studentCount = this.gradeList[i].studentCount + item.studentCount;
                this.gradeList[i].objsubjects = [...item.subjects];
                this.gradeList[i].objclasses.push({ _id: item._id, name: item.name });
                if (classes) {
                  classes = classes + ', ' + item.name;
                } else {
                  classes = item.name;
                }
                subjects = '';
                item.subjects.forEach(element => {
                  if (subjects) {
                    tempSub.push(element);
                    subjects = subjects + ', ' + element.name;
                  } else {
                    tempSub.push(element);
                    subjects = element.name;
                  }
                  if (subjects) {
                    this.hasSubjects = true;
                  }
                });
              }
              if (this.classList && this.classList.indexOf(item.name) === -1) {
                this.classList.push(item.name);
              }
            } //
          });
          this.gradeList[i].teacherCount = teacherArr.length;
          if (classes) {
            this.gradeList[i].classes = classes;
          }
          // if ( subjects ) {
          this.gradeList[i].subjects = subjects;
          // }
          i++;
        }
        this.loaded = true;
        setTimeout(() => { this.tabInit(); this.dropdownInit(); }, 300);

        // Bottom loop is to merge grades which are not assigned with classes.
        let exGrades = [];
        let tmpFlag = false;
        let j;
        if (this.projectData) {
          for (let i = 0; i < this.projectData.grades.length; i++) {
            tmpFlag = false;
            for (j = 0; j < this.gradeList.length; j++) {
              if (this.projectData.grades[i]._id === this.gradeList[j]._id) {
                tmpFlag = true;
                break;
              }
            }
            if (tmpFlag === false && j === this.gradeList.length) {
              exGrades.push(this.projectData.grades[i]);
            }
          }
        }

        this.keySubjectListDropdownForTeacher = [...tempSub];
        this.gradeList = this.gradeList.concat(exGrades);
        this.gradeListFilter = Object.keys(tmpGradeList).map(key => tmpGradeList[key]);
        this.gradeListFilter = this.gradeListFilter.concat(exGrades);
      },
      (err) => {
        this.loaded = true;
        this.tabInit();
        console.log('ERROR: ' + err);
        // add error handler
      },
      () => {
        // console.log('COMPLETED');
        this.tabInit();
      }
    );
  }

  getGradeSubjectList(filterList) {
    this.schoolService.listGradeSubject(this.school_id, filterList).subscribe(
      (response) => {
        if (response.length === undefined) {
          this.gradeSubjectList = [];
        } else {
          this.gradeSubjectList = response;
        }
      },
      (err) => {
        console.log('ERROR: ' + err);
      },
      () => {
        // console.log('COMPLETED');
      }
    );
  }

  getStudentList(filterType?, data?) {
    this.myrole = 'Student';
    if (filterType) {
      this.getUserList(filterType, data);
    } else {
      this.getUserList();
    }
  }

  getTeacherList(filterType?, data?) {
    this.myrole = 'Teacher';
    if (filterType) {
      this.getUserList(filterType, data);
    } else {
      this.getUserList();
    }
  }

  getAdminList(filterType?, data?) {
    this.myrole = 'SchoolAdmin';
    if (filterType) {
      this.getUserList(filterType, data);
    } else {
      this.getUserList();
    }
  }

  getUserList(filterType?, data?) {
    const filterList = { sort_by: '_id', sort_order: 'desc', filter_by: 'school_id', filter_value: this.school_id };
    this.studentsTabLoaded = false;
    if (this.myrole) {
      if (data) {
        filterList.filter_by = filterList.filter_by + ',' + 'role_id';
        data = this.getRoleID(data);
        filterList.filter_value = filterList.filter_value + ',' + data;
      }
    }
    if (filterType === 'gradeId') {
      filterList.filter_by = filterList.filter_by + ',' + 'grade_id';
      if (data) {
        filterList.filter_value = filterList.filter_value + ',' + data;
      }
    }
    if (filterType === 'classId') {
      filterList.filter_by = filterList.filter_by + ',' + 'class_id';
      if (data) {
        filterList.filter_value = filterList.filter_value + ',' + data;
      }
    }
    if (filterType === 'subjectId') {
      filterList.filter_by = filterList.filter_by + ',' + 'subject_id';
      if (data) {
        filterList.filter_value = filterList.filter_value + ',' + data;
      }
    }

    if (this.confirmFor === 'user') {
      this.closeDialogModal('successModal');
      this.curUserData.first_name=this.curUserData.first_name.charAt(0).toUpperCase() +this.curUserData.first_name.slice(1);
      this.curUserData.last_name = this.curUserData.last_name.charAt(0).toUpperCase() +this.curUserData.last_name.slice(1);
      this.subTitleMessage = this.curUserData.first_name + ' ' + this.curUserData.last_name;
      this.detailMessage = '';
      this.confirmFor = '';

      let roleText = '';
      switch (this.curUserData.role.name) {
        case 'SchoolAdmin':
          roleText = 'School admin';
          break;
        default:
          roleText = this.curUserData.role.name;
          break;
      }

      if (this.currentView === 'read' && !this.newPassword) {
        if (this.curUserData.active === true) {
          this.titleMessage = roleText + " " + this.translate.instant('archived');
        } else {
          this.titleMessage = roleText + " " + this.translate.instant('activated');
        }
      } else if (this.currentView === 'read' && this.newPassword) {
        this.titleMessage = this.translate.instant('Password updated');
        this.newPassword = '';
      } else if (this.currentView === 'add') {
        if (roleText === 'Student') {
          this.titleMessage = this.translate.instant('New') + " " + this.translate.instant('student') + " " + this.translate.instant('added');
        }
        else if (roleText === 'Teacher') {
          this.titleMessage = this.translate.instant('New') + " " + this.translate.instant('teacher') + " " + this.translate.instant('added');
        } else {
          this.titleMessage = this.translate.instant('New') + " " + roleText + " " + this.translate.instant('added');
        }
      }
      else if (this.currentView === 'edit') {
        this.titleMessage = roleText + " " + this.translate.instant('updated');
      }
      else if (this.currentView === 'approve') {
        this.titleMessage = this.translate.instant('New') + " " + this.translate.instant('student') + " " + this.translate.instant('added');;
        this.subTitleMessage = this.translate.instant('This student account is now activated.');
      }
      else if (this.currentView === 'deny') {
        this.titleMessage = this.translate.instant('Access request denied');
        this.subTitleMessage = this.translate.instant('The account has been denied. The request will be deleted.');
      }
      this.closeDialogModal('userModal');
      this.openDialogModal('successModal');
    }

    this.userService.search(filterList).subscribe(
      (response) => {
        this.userListData = response;
        console.log("this.userListData >>>> " + JSON.stringify(this.userListData))
        if (this.userListData && this.userListData.length) {
          this.studentCount = this.userListData.filter(i => i.role.name === 'Student').length;
          this.teacherCount = this.userListData.filter(i => i.role.name === 'Teacher').length;
          this.adminCount = this.userListData.filter(i => i.role.name === 'SchoolAdmin').length;
          this.teacherList = this.userListData.filter(i => i.role.name === 'Teacher');
        }
        const tempSubjectList = [];
        const tempGradeList = [];
        const tempClassList = [];
        // TODO: Need to check for large data.

        for (let j = 0; j < this.userListData.length; j++) {
          if (this.userListData[j].class.name === undefined) {
            this.userListData[j].class.name = '';
          }

          if (this.userListData[j].active) {
            this.userListData[j].ustatus = "active";
          }
          if (!this.userListData[j].active || this.userListData[j].active == undefined) {
            this.userListData[j].ustatus = "archived";
          }
          if (this.userListData[j].request_status && this.userListData[j].request_status == "new") {
            this.userListData[j].ustatus = "accessrequest";
          }
          const dateObj = new Date(this.userListData[j].date_of_birth);

          if (typeof this.userListData[j].date_of_birth !== 'undefined' && this.userListData[j].date_of_birth !== null && dateObj.toString() !== 'Invalid Date') {
            // this.userListData[j].date_of_birth =  this.datepipe.transform(dateObj, 'dd-MM-yyyy');
            this.userListData[j].date_of_birth = this.datepipe.transform(dateObj, 'yyyy-MM-dd');
          }
          if (this.userListData[j].role.name === 'Teacher') {
            if (typeof this.userListData[j].key_subject !== 'undefined') {
              tempSubjectList.push(this.userListData[j].key_subject);
            }
          }

          if (this.userListData[j].role.name === 'Student' && this.userListData[j].class !== undefined &&
            this.userListData[j].class.grade.hasOwnProperty('name')) {
            tempGradeList.push(this.userListData[j].class.grade);
            tempClassList.push(this.userListData[j].class.name);
          }
        }
        if (tempSubjectList.length) {
          this.subjectList = [...tempSubjectList];
        }
        this.gradeListStudFilter = [...tempGradeList];
        this.classListStudFilter = Array.from(new Set(tempClassList));
      },
      (err) => {
        console.log('ERROR: ' + err);
      },
      () => {
        this.studentsTabLoaded = true;
      }
    );
  }
  showSuccessDialog(evt) {
    this.closeDialogModal('userModal');
    this.titleMessage = this.translate.instant('Teacher') + " " + this.translate.instant('Added');
    this.subTitleMessage = this.projectData.name + ', ' + this.schoolData.name;
    this.detailMessage = '';
    this.confirmFor = '';
    this.openDialogModal('successModal');
    this.tabInit();
  }

  addUser() {
    if (this.project_id) {
      this.userForm.project_id = this.project_id;
    }

    if (this.currentView === 'read' && !this.newPassword) {
      this.enableDisableUser();
      return;
    }

    if (this.currentView === 'read' && this.newPassword) {
      this.resetUserPassword(this.curUserData._id, this.newPassword);
      return;
    }

    if(!this.isUserSaveBtnClicked) {
      this.isUserSaveBtnClicked = true;
      this.addUserOnSingleClick();
    }
    // if (this.clickTimeout) {
    //   this.setClickTimeout(() => {
    //     this.addUserOnSingleClick();
    //   });
    // } else {
    //   this.setClickTimeout(() =>  
    //    this.addUserOnSingleClick());
    // }
    
    this.tabInit();
  }

  private addUserOnSingleClick(){
    this.userForm.onUserFormSubmit().then(res => {
      this.confirmFor = 'user';
      this.curUserData = this.userFormGroup.value;
      this.curUserData.role = { name: this.myrole };
      this.getGradeList(this.school_id);
    });
  }

  public setClickTimeout(callback) {
    // clear any existing timeout
    clearTimeout(this.clickTimeout);
    this.clickTimeout = setTimeout(() => {
      this.clickTimeout = null;
      callback();
    }, 900);
  }

  allowAccess() {
    this.btnTextDeny = '';
    this.titleModal = this.translate.instant('Assign') + " " + this.translate.instant('New') + " " + this.translate.instant('Student');
    this.currentView = 'approve';
    this.btnTextAllow = 'Assign';
    this.btnStatusAdd = true;
    this.openDialogModal('userModal');

  }

  allowAccessToUser() {
    this.userForm.onUserFormSubmit();
    this.confirmFor = 'user';
    this.closeDialogModal('userModal');
    this.currentView = 'approve';
    this.curUserData = this.userFormGroup.value;
    this.curUserData.role = { name: this.myrole };
    this.getUserList();
  }

  cancelUser() {
    this.currentView = 'read';
    this.newPassword = '';
    this.btnSendStatus = false;
    this.closeDialogModal('userModal');
    this.dpFlag = false;
  }

  // denyUser() {
  //   this.closeDialogModal('userModal');
  //   this.currentView='deny';
  //   this.getUserList();
  //   this.titleMessage = 'Request Denied';
  //   this.subTitleMessage = 'You have denied access to this request. The request will be deleted.';
  //   this.detailMessage = 'Select OK to confirm.';
  //   this.openDialogModal('confirmModal');
  // }

  updateUser() {
    this.userUpdated = true;
    this.confirmFor = '';
    this.btnTextAdd = this.translate.instant('Add');
    this.btnStatusAdd = false;
    this.teacherModalType = 'edit';
    this.btnTextCancel = 'Cancel';
    this.btnTextSend = '';
    this.currentView = 'edit';
  }

  openNewUserRequestModal(myrole, type?, data?) {
    this.userFormGroup.reset();
    this.btnStatusAdd = true;
    if (myrole && myrole === 'Student' && data.request_status === 'new') {
      this.titleModal = this.translate.instant('New Student Access Request');
    }
    this.currentView = type;
    this.curUserData = data;
    this.user_id = data._id;

    this.userFormGroup.patchValue(data);
    if (data.gender) {
      this.userFormGroup.get('gender').patchValue(data.gender.charAt(0).toUpperCase() + data.gender.slice(1));
    }
    this.btnTextSend = '';
    this.btnTextDeny = 'Deny Access';
    this.btnTextCancel = 'Cancel';
    this.btnTextAllow = 'Allow Access';
    this.btnTextEdit = '';
    this.btnTextAdd = '';
    this.btnStatusAdd = false;
    this.openDialogModal('userModal');
  }

  openUserModal(myrole, type?, data?) {
    this.btnTextDeny = '';
    if (myrole && myrole === 'Student') {
      this.userFormGroup = this.fb.group(projectforms.formStudent);
    } else if (myrole && myrole === 'Teacher') {
      this.userFormGroup = this.fb.group(projectforms.formTeacher);
    } else {
      this.userFormGroup = this.fb.group(projectforms.formUser);
    }
    this.userFormGroup.reset();
    this.btnStatusAdd = true;
    if (myrole && myrole === 'Student') {
      this.userForm.getGradeClassList();
      this.titleModal = this.translate.instant('Add new student');
    } else if (myrole && myrole === 'Teacher') {
      this.titleModal = this.translate.instant('Add new teacher');
    } else if (myrole && myrole === 'SchoolAdmin') {
      this.titleModal = this.translate.instant('Add new school admin');
    }
    this.currentRole = myrole;

    this.user_id = undefined;
    this.curUserData = {};

    this.btnTextAdd = this.translate.instant('Add');
    this.btnTextCancel = 'Cancel';
    this.btnTextEdit = '';
    this.btnTextSend = '';
    this.currentView = 'add';
    this.btnTextAllow = '';
    this.btnTextDeny = '';
    this.isSchoolAdmin = false;

    if (data && data.first_name) {
      this.btnTextEdit = 'Edit';
      this.userForm.loginGenerated = false;
      this.curUserData = data;
      this.currentView = 'read';
      this.user_id = data._id;

      this.userFormGroup.patchValue(data);
      if (data.gender) {
        this.userFormGroup.get('gender').patchValue(data.gender.charAt(0).toUpperCase() + data.gender.slice(1));
      }
      if (data.class && data.class.name) {
        if (data.class && data.class.grade) {
          this.userFormGroup.get('grade').patchValue(data.class.grade);
          this.userForm.populateClass('grade', data.class.grade);
          this.userFormGroup.get('class').patchValue(data.class);
        }
      } else {
        this.userFormGroup.get('grade').patchValue('');
        this.userFormGroup.get('class').patchValue('');
      }

      if (!data.active) {
        this.curUserData.active = false;
      }

      this.titleModal = '';
      if (data.active) {
        if (myrole && myrole === 'Student') {
          this.btnTextSend = this.translate.instant('Generate new password');
        } else if (myrole && myrole === 'Teacher') {
          this.btnTextSend = this.translate.instant('Generate new password');
        } else if (myrole && myrole === 'SchoolAdmin') {
          this.btnTextSend = this.translate.instant('Email password reset');
        }
      } else {
        this.btnTextSend = '';
      }

      this.btnTextCancel = 'Close';
      this.btnTextAdd = null;
      if (this.loggedInUser.role.name === 'SchoolAdmin' && data._id === this.loggedInUser._id) {
        this.isSchoolAdmin = true;
      }
    }
    this.dpFlag = true;
    this.isUserSaveBtnClicked = false;
    this.openDialogModal('userModal');
  }

  openUserBulkUploadModal(myrole) {

    if (myrole && myrole === 'Student') {
      this.userForm.getGradeClassList();
      this.titleModal = this.translate.instant('Add multiple students');
    } else if (myrole && myrole === 'Teacher') {
      this.titleModal = this.translate.instant('Add multiple teachers');
    }
    this.btnTextAdd = this.translate.instant('Verify');
    this.btnTextCancel = 'Cancel';
    this.btnTextSend = '';
    this.currentView = 'add';
    this.btnTextAllow = '';
    this.btnTextDeny = '';
    this.btnStatusAdd = true;
    this.isHeader = true;
    // this.xlssample.filename = '';
    this.xlssample = {};
    if (myrole && myrole === 'Student') {
      this.openDialogModal('userBulkUploadModal');
      this.closeDialogModal('bulkVerifyModal');
    } else if (myrole && myrole === 'Teacher') {
      this.openDialogModal('teacherBulkUploadModal');
    }

  }

  confirmEnableArchiveUser(checkboxstatus) {
    if (this.curUserData.active !== checkboxstatus) {
      this.btnTextAdd = 'Save';
      this.btnStatusAdd = false;
      this.btnTextCancel = 'Cancel';
      this.btnTextEdit = '';
      this.btnTextSend = '';
      this.currentView = 'read';
      this.titleModal = '';
    } else {
      this.titleModal = '';
      this.btnTextCancel = 'Close';
      this.btnTextAdd = '';
      this.btnTextEdit = this.translate.instant('Edit');
      if (this.curUserData.role.name === 'Student') {
        this.btnTextSend = this.translate.instant('Generate New Password');
      } else if (this.curUserData.role.name === 'Teacher') {
        this.btnTextSend = this.translate.instant('Generate New Password');
      } else if (this.curUserData.role.name === 'SchoolAdmin') {
        this.btnTextSend = this.translate.instant('Email password reset');
      }
    }
    this.openDialogModal('userModal');
  }

  enableUserEdit(data) {
    this.btnTextAdd = 'Save';
    this.btnStatusAdd = true;
    this.btnTextCancel = 'Cancel';
    this.btnTextSend = '';
    this.currentView = 'edit';
    this.titleModal = '';
    this.btnTextEdit = '';
    this.btnStatusEdit = true;
    this.openDialogModal('userModal');
  }

  GenerateOrSend() {
    // console.log('GenerateOrSend jani')
    if (this.myrole === 'SchoolAdmin') {
      const user = {
        user_id: '',
        first_name: '',
        last_name: '',
        email: ''
      };
      user.user_id = this.curUserData._id;
      user.first_name = this.curUserData.first_name;
      user.last_name = this.curUserData.last_name;
      user.email = this.curUserData.contact.email;
      this.projectService.sendMail(user).subscribe(
        (response) => {
          // alert( 'RESPONSE ' + JSON.stringify(response));
          this.btnStatusSend = true;
          this.btnSendStatus = true;
          this.btnTextSend = this.translate.instant('Password email sent');
        },
        (err) => {
          console.log('ERROR: ' + err);
        },
        () => {
          // console.log( 'COMPLETED' );

          // hide modal enable success modal
        }
      );
    } else {
      this.newPassword = this.generatePassword();
      this.btnTextAdd = 'Save';
      this.btnTextEdit = '';
      this.btnStatusAdd = false;
      this.btnTextCancel = 'Cancel';
      this.currentView = 'read';
      this.titleModal = '';
      this.btnSendStatus = true;
      this.btnTextSend = this.translate.instant('New password generated');
    }
  }


  userFormChange(flag) {
    if (flag && this.userFormGroup.invalid) {
      this.btnStatusAdd = true;
    } else {
      this.btnStatusAdd = false;
    }
  }

  refreshUserList(flag) {
    this.getUserList();
  }

  editSchoolOverview() {
    const navigationExtras: NavigationExtras = {
      // relativeTo: this.route
    };
    this.router.navigate(['/schoolmanagement', 'editschool', this.school_id], navigationExtras);
  }

  getRoleList() {
    this.userService.listRoles().subscribe(
      (response) => {
        this.roleListData = response;
      },
      (err) => {
        console.log('ERROR: ' + err);
      },
      () => {
        // console.log( 'COMPLETED' );
      }
    );
  }

  getRoleID(name: string) {
    if (this.roleListData.length) {
      for (let i = 0; i < this.roleListData.length; i++) {
        if (this.roleListData[i].name === name) {
          return this.roleListData[i]._id;
        }
      }
    }
    return;
  }

  getRegionList(project_id) {
    this.schoolService.listRegion(project_id).subscribe(
      (response) => {
        this.regionList = response;
        this.regionList.push({ _id: 'new', name: ' - New region', description: 'add new' });
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
        this.regionList = [];
        this.regionList.push({ _id: 'new', name: ' - New region', description: 'add new' });
      },
      () => {
        // this.tabInit();
        // console.log('COMPLETED');
      }
    );
  }

  getSchoolCategoryList() {
    //
    this.schoolService.listSchoolCategory().subscribe(
      (response) => {
        this.schoolCategoryList = response;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        // console.log('COMPLETED');
      }
    );
  }

  getCountryList() {
    this.projectService.listCountry().subscribe(
      (response) => {
        this.countryList = response;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        // console.log('COMPLETED');
      }
    );
  }

  editSchoolModal(data) {
    this.edited = true;
    this.schoolForm.data = data;
    this.curView = 'read';
    this.btnTextCancel = 'Close';
    this.btnTextAdd = '';
    this.btnTextEdit = 'Edit';
    this.openDialogModal('schoolModal');
  }

  enableSchoolEdit() {
    console.log('edit school');
    this.btnTextAdd = 'Save';
    this.btnStatusAdd = false;
    this.btnTextEdit = '';
    /* this.btnStatusEdit = true; */
    this.btnTextCancel = 'Cancel';
    this.curView = 'edit';
    this.schoolForm.school_id = undefined;
    this.schoolForm.project_id = this.project_id;
    this.schoolForm.action = '';
    this.schoolForm.message = '';
    this.schoolForm.school_id = this.schoolData._id;
    this.schoolForm.schoolForm.patchValue(this.schoolData);
    this.btnTextAdd = 'Save';
    this.openDialogModal('schoolModal');
  }

  resetSchool() {
    // alert('reset clicked');
    //
  }

  addSchool() {
    console.log('add school');
    if (this.curView === 'read') {
      this.closeDialogModal('schoolModal');
      this.enableDisableSchool();
      return;
    } else {
      if (this.project_id) {
        this.schoolForm.project_id = this.project_id;
      }
      this.schoolForm.onSchoolFormSubmit().then(()=>{
        if (this.school_id) {
          this.getSchoolDetails(this.school_id, true);
        }
      });       
    }
  }

  cancelSchool() {
    //
    this.closeDialogModal('schoolModal');
  }
  confirmTeacherEnableArchive() {
    this.confirmFor = 'Teacher';
    this.btnTextAdd = 'Save';
    this.btnStatusAdd = false;
    this.teacherModalType = 'edit';
    this.btnTextCancel = 'Cancel';
    this.btnTextSend = '';
  }

  /* grade class subject */
  openClassSubjectModal(data) {
    if (data) {
      this.currentView = 'read';
      this.curGradeData = data;
      this.classSubjectTitle = data.name;
      this.classSubjectInfo = this.schoolData.name;
      this.btnTextAdd = null;
      this.btnTextCancel = 'Close';
      this.btnTextEdit = 'Edit';
      this.openDialogModal('classSubjectModal');
    }
  }

  editClassSubjectModal() {
    this.currentView = 'edit';
    this.btnTextAdd = 'Save';
    this.btnTextCancel = 'Cancel';
    this.btnTextEdit = '';
    const frmControl = this.fgClassSubject.controls['classes'] as FormArray;
    if (frmControl.length > 0) {
      this.saveButtonStatus = false;
    }

    this.openDialogModal('classSubjectModal');
  }

  cancelClassSubject() {
    this.currentView = 'read';
    this.closeDialogModal('classSubjectModal');

  }
  cancelDelete() {
    this.closeDialogModal('errorModal');
  }

  removeClassAndUpdate() {
    /* const clsID = this.removedClassArr._id; */

    this.schoolService.removeClass(this.removedClassArr, this.school_id).subscribe(
      (response) => { },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        this.closeDialogModal('classSubjconfirmModal');
        this.removedClassArr = [];
        this.removedSubjectArr = [];
        this.updateClassSubject();
      }
    );
  }


  updateClassSubject() {
    /* show confirmation dialog - Kajal */
    if (this.removedClassArr.length > 0 && this.removedSubjectArr.length > 0) {
      this.titleMessage = this.translate.instant('Remove Class(es) & subject(s)?');
      this.subTitleMessage = this.translate.instant('All students and teachers assigned to this class will become unassigned.');
      this.detailMessage = this.translate.instant('Re-assignment and activation of students and teachers will need to be completed manually.');
      this.listMessage = this.removedClassName;
      this.listMessage1 = this.removedSubjectArr;
      this.closeDialogModal('classSubjectModal');
      this.openDialogModal('classSubjconfirmModal');
    } else if (this.removedSubjectArr.length > 0) {
      this.titleMessage = this.translate.instant('Remove subject(s)?');
      this.subTitleMessage = this.translate.instant('All students and teachers assigned to these classes and subjects will become unassigned.');
      this.detailMessage = this.translate.instant('If re-assignment is required this will need to be completed manually.');
      this.listMessage1 = this.removedSubjectArr;
      this.closeDialogModal('classSubjectModal');
      this.openDialogModal('classSubjconfirmModal');
    } else if (this.removedClassArr.length > 0) {
      this.titleMessage = this.translate.instant('Remove Class(es)?');
      this.subTitleMessage = this.translate.instant('All students and teachers assigned to this class will become unassigned.');
      this.detailMessage = this.translate.instant('Re-assignment and activation of students and teachers will need to be completed manually.');
      this.listMessage = this.removedClassName;
      this.closeDialogModal('classSubjectModal');
      this.openDialogModal('classSubjconfirmModal');
    } else {
      const data = [];
      const subject_ids = [];
      if (this.fgClassSubject.value.subjects) {
        this.projectData.subjects.forEach(item => {
          if (this.fgClassSubject.value.subjects.find(x => x.name === item.name)) {
            subject_ids.push(item._id);
          }
        });
      }
      this.fgClassSubject.value.classes.forEach(item => {
        if (item.name !== '') {
          data.push({
            _id: item._id,
            name: item.name.trim(),
            grade_id: this.curGradeData._id,
            school_id: this.school_id,
            subjects: subject_ids
          });
        }
      });
      if (data.length > 0) {
        this.schoolService.addGradeClass(data, this.school_id).subscribe(
          (response) => {
            this.getGradeList(this.school_id);
            this.getUserList();
          },
          (err) => {
            const errorHandlerObj = new MyErrorHandler();
            const errorHandler = errorHandlerObj.handleError(err);
            if (errorHandler.isSssionExpired) {
              this.router.navigate(['/login']);
              return true;
            }
          },
          () => {
            // if (this.isSubjectRemoved){
            this.titleMessage = this.translate.instant('Class') + " " + this.translate.instant('subject') + " " + this.translate.instant('updated');
            this.subTitleMessage = this.schoolData.name;
            this.detailMessage = '';
            this.closeDialogModal('classSubjectModal');
            this.openDialogModal('successModal');
            // }
            // else{
            //   this.titleMessage = 'Remove subjects?';
            //   this.subTitleMessage = 'All students and teachers assigned to these subjects will become unassigned.';
            //   this.detailMessage = 'If re-assignment is required this will need to be completed manually.';
            //   this.listMessage = this.removedSubjectArr;
            //   this.closeDialogModal('classSubjectModal')
            //   this.openDialogModal('classSubjconfirmModal');
            // }
          }
        );
      } else {
        this.getGradeList(this.school_id);
        this.closeDialogModal('errorModal');
        this.openDialogModal('successModal');
      }
    }
  }
  /* removeClassandSubject(){
    if (this.fgClassSubject.value.subjects){
      this.projectData.subjects.forEach(item => {
        if (this.fgClassSubject.value.subjects.find(x => x.name === item.name) ) {
          subject_ids.push(item._id);
          
        }
      });
    }
  } */
  removeClass(clsObj) {
    if (clsObj) {
      this.removedClassArr.push(clsObj._id);
      this.removedClassName.push(clsObj);
      const frmControl = this.fgClassSubject.controls['classes'] as FormArray;
      if (frmControl.length > 0) {
        this.saveButtonStatus = false;
      } else {
        this.saveButtonStatus = true;
      }
    }
  }

  removeSubject(subjId) {
    if (subjId) {
      this.removedSubjectArr.push(subjId);
      this.isSubjectRemoved = subjId.removed;
      const frmControl = this.fgClassSubject.controls['subjects'] as FormArray;
      console.log('jani fmcontrl');
      console.log(frmControl)
      /* if (frmControl.length > 0){
        this.saveButtonStatus = false;
      }else{
        this.saveButtonStatus = true;
      } */
    }
  }

  addClass(clsId) {
    const frmControl = this.fgClassSubject.controls['classes'] as FormArray;
    if (frmControl.length > 0) {
      this.saveButtonStatus = false;
    } else {
      this.saveButtonStatus = true;
    }
  }

  resetUser() {
    // alert('reset clicked');
    //
  }

  tabHeadingInitial(data) {
    let temp1;
    let temp2;
    if (data !== undefined) {
      const temp = data.split(' ');
      temp1 = temp[0].charAt(0).toUpperCase();
      if (temp.length > 1) {
        temp2 = temp[1].charAt(0).toUpperCase();
      } else {
        temp2 = '';
      }
    }
    return temp1 + temp2;
  }

  showAddNewBtns(obj) {
    const btnAddSchool = document.querySelector('#btn_add_new_school') as HTMLElement;
    const btnAddPartner = document.querySelector('#btn_add_new_partner') as HTMLElement;
    const btnAddAdmin = document.querySelector('#btn_add_new_admin') as HTMLElement;

    if (btnAddSchool) {
      btnAddSchool.style.display = 'none';
    }
    if (btnAddPartner) {
      btnAddPartner.style.display = 'none';
    }
    if (btnAddAdmin) {
      btnAddAdmin.style.display = 'none';
    }

    if (obj === 1) { // show school
      if (btnAddSchool) {
        btnAddSchool.style.display = 'block';
      }
    } else if (obj === 2) { // show partner
      if (btnAddPartner) {
        btnAddPartner.style.display = 'block';
      }
    } else if (obj === 3) { // show admin
      if (btnAddAdmin) {
        btnAddAdmin.style.display = 'block';
      }
    }
    this.tabInit();
  }

  downloadTemplate() {
    const downloadAddStudentsAndTeachersTemplate = './assets/template/SchoolUserProvisionTemplate.xlsx';
    window.open(downloadAddStudentsAndTeachersTemplate);
  }

  downloadTeacherList(project_id: string) {
    const filterList = { sort_by: '_id', sort_order: 'desc', filter_by: 'school_id', filter_value: this.school_id };

    filterList.filter_by = filterList.filter_by + ',' + 'role_id';
    const role = this.getRoleID('Teacher');
    filterList.filter_value = filterList.filter_value + ',' + role;

    this.userService.downloadUserList('teachers', filterList).subscribe(
      (response) => {
        this.downloadFile(response);
      }
    );
  }

  downloadStudentList(projectId: string) {
    const filterList = { sort_by: '_id', sort_order: 'desc', filter_by: 'school_id', filter_value: this.school_id };

    filterList.filter_by = filterList.filter_by + ',' + 'role_id';
    const role = this.getRoleID('Student');
    filterList.filter_value = filterList.filter_value + ',' + role;

    this.userService.downloadUserList('students', filterList).subscribe(
      (response) => {
        this.downloadFile(response);
      }
    );
  }

  downloadGradeList(projectId: string) {
    const filterList = { sort_by: '_id', sort_order: 'desc', filter_by: 'school_id', filter_value: this.school_id };

    filterList.filter_by = filterList.filter_by + ',' + 'role_id';
    const role = this.getRoleID('Student');
    filterList.filter_value = filterList.filter_value + ',' + role;

    this.userService.downloadUserList('students', filterList).subscribe(
      (response) => {
        this.downloadFile(response);
      }
    );
  }

  downloadFile(data: Blob) {
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  }

  filterGradeList(type, value) {
    //
  }


  callEnableDisable() {
    // alert(this.currentView);
    if (this.currentView === 'request') {
      this.denyRequestToUser();
      return;
    }
    if (this.confirmFor === 'Teacher') {
      this.enableDisableUser();
    } else {
      this.enableDisableSchool();
    }
    if (this.currentView === 'edit') {

    }
  }

  denyConfirmToUser() {
    this.titleMessage = 'Are you sure you want to delete this user?';
    this.subTitleMessage = 'This user will be deleted.';
    
    this.detailMessage = '';
    this.listMessage = '';
    this.listMessage1 = '';
    this.closeDialogModal('userModal');
    this.openDialogModal('confirmModalDenyAccess');
  }
  denyRequestToUser() {
    this.userService.denyAccess(this.user_id).subscribe(
      (response) => {
        this.confirmFor = 'user';
        //this.closeDialogModal('userModal');
        this.closeDialogModal('confirmModalDenyAccess');
        this.currentView = 'deny';
        this.getUserList();
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => { }
    );
  }

  enableDisableUser() {
    if (this.curUserData.active === true) {
      this.disableUser(this.curUserData._id);
    } else {
      this.enableUser(this.curUserData._id);
    }
  }

  enableDisableSchool() {
    if (this.schoolData.active === true) {
      this.disableSchool(this.school_id);
    } else {
      this.enableSchool(this.school_id);
    }
    this.openDialogModal('successModal')
  }

  disableSchool(school_id) {
    this.schoolService.disable(school_id).subscribe(
      (response) => {
        this.getSchoolDetails(this.school_id, false);

      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        this.getSchoolDetails(this.school_id, false);
        this.closeDialogModal('confirmModal');
      }
    );
  }

  enableSchool(school_id) {
    this.schoolService.enable(school_id).subscribe(
      (response) => {
        this.getSchoolDetails(this.school_id, false);

      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        this.getSchoolDetails(this.school_id, false);
        this.closeDialogModal('classSubjconfirmModal');
      }
    );
  }

  disableUser(user_id) {
    this.userService.disable(user_id).subscribe(
      (response) => {
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        this.confirmFor = 'user';
        this.getUserList();
        this.closeDialogModal('userModal');
      }
    );
  }

  enableUser(user_id) {
    this.userService.enable(user_id).subscribe(
      (response) => {
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        this.confirmFor = 'user';
        this.getUserList();
        this.closeDialogModal('userModal');
      }
    );
  }

  resetUserPassword(user_id, newpass) {
    const data = {
      username: this.curUserData.username,
      domain: this.curUserData.domain,
      password: newpass
    };

    this.userService.resetuserpass(user_id, data).subscribe(
      (response) => {
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        this.confirmFor = 'user';
        this.myrole = '';
        this.getUserList();
        this.closeDialogModal('userModal');
      }
    );
  }

  schoolUpdated() {
    this.closeDialogModal('schoolModal');
    this.titleMessage = this.translate.instant('School') + " " + this.translate.instant('updated');
    this.subTitleMessage = this.schoolData.name;
    this.detailMessage = '';
    this.openDialogModal('successModal');
  }

  confirmEnableArchiveSchool(checkboxstatus) {
    if (this.schoolData.active !== checkboxstatus) {
      this.confirmFor = 'school';
      this.btnTextAdd = 'Save';
      this.btnStatusAdd = false;
      this.btnTextCancel = 'Cancel';
      this.btnTextEdit = '';
      this.edited = false;
    } else {
      this.confirmFor = '';
      this.btnTextAdd = '';
      this.btnStatusAdd = false;
      this.btnTextCancel = 'Close';
      this.btnTextEdit = 'Edit';
      this.edited = true;
    }
  }

  send() {
    this.confirmFor = 'user';
    this.btnTextAdd = 'Save';
    this.btnStatusAdd = false;
    this.teacherModalType = 'edit';
    this.btnTextCancel = 'Cancel';
    this.newPassword = this.generatePassword();
  }

  generatePassword() {
    let retVal = '';
    //alert("this.curUserData.role-"+JSON.stringify(this.curUserData));
    if (this.curUserData.role.name == 'Student') {
      var name = this.curUserData.first_name.trim() + this.curUserData.last_name.trim();
      var digit = Math.floor(Math.random() * 4);
      var temp;
      var arr = this.curUserData.date_of_birth.split('-');
      if (arr[1].length == 1)
        arr[1] = '0' + arr[1]; //mm
      if (arr[2].length == 1)
        arr[2] = '0' + arr[2]; //dd
      if (digit == 0) {
        temp = Math.floor(1000 + Math.random() * 9000); //generated 4 digit random number         
      }
      else if (digit == 1) {
        temp = arr[2] + arr[1];  //ddmm         
      }
      else if (digit == 2) {
        temp = arr[1] + arr[0].substr(arr[0].length - 2); //finds last yy from yyyy   //mmyy         
      }
      else if (digit == 3) {
        temp = arr[2] + arr[0].substr(arr[0].length - 2);  //ddyy         
      }
      retVal = name.substring(0, 3) + temp;
      retVal = retVal.toLowerCase();
      //console.log("password--" + retVal);
      return retVal;
    }
    else {
      const length = 8;
      const charset = 'abcdefghijklmnopqrstuvwxyz';
      //let retVal = '';
      for (let i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      return retVal;
    }
  }

  openAssignTeacherModal(cl) {
    this.getUserList();
    this.titleAssignTeacherModal = cl.grade.name + ' ' + cl.name;
    this.curGradeData = cl.grade;
    this.curClass = { ...cl };
    this.fgAssignTeacher.reset();
    this.fgAssignTeacher.get('class_id').patchValue(cl.name);
    this.fgAssignTeacher.get('subjectteacher').patchValue([this.patchSubjectTeacher('', '', '')]);
    this.addAssignmentToForm();
    this.btnTextAdd = this.translate.instant('Update');
    this.btnTextCancel = 'Cancel';
    this.openDialogModal('assignTeacherModal');
  }

  saveTeacherClass() {
    const subjectteacher = [];
    this.fgAssignTeacher.value.subjectteacher.forEach(item => {
      if (item.subject !== null &&
        item.teacher && item.teacher._id !== null &&
        item.teacher_two && item.teacher_two._id !== null) {
        subjectteacher.push({
          subject_id: item.subject._id,
          teacher_id: item.teacher._id,
          teacher_two_id: item.teacher_two._id
        });
      } else if (item.subject !== null &&
        item.teacher && item.teacher._id !== null) {
        subjectteacher.push({
          subject_id: item.subject._id,
          teacher_id: item.teacher._id,
          teacher_two_id: null
        });
      } else if (item.subject !== null) {
        subjectteacher.push({
          subject_id: item.subject._id,
          teacher_id: null,
          teacher_two_id: null
        });
      }

    });
    this.schoolService.updateAssignSubjectTeacher(this.curClass._id, { subjectteacher }).subscribe(
      (response) => {
        this.getGradeList(this.school_id);
      },
      (err) => {
        console.log('ERROR: ' + err);
      },
      () => {
        this.closeDialogModal('assignTeacherModal');
      }
    );
  }

  renderSelect(item) {
    if (item === 'grade') {
      // jQuery('.selectGrade').selectpicker('render');
    } else if (item === 'subject') {
      // jQuery('.selectSubject').selectpicker('render');
    } else if (item === 'class') {
      // jQuery('.selectClass').selectpicker('render');
    } else if (item === 'status') {
      // jQuery('.selectStatus').selectpicker('render');
    } else if (item === 'keySubject') {
      // jQuery('.selectKeySubject').selectpicker('render');
    }
  }

  refreshSelect(item) {
    if (item === 'grade') {
      // jQuery('.selectGrade').selectpicker('refresh');
    } else if (item === 'subject') {
      // jQuery('.selectSubject').selectpicker('refresh');
    } else if (item === 'class') {
      // jQuery('.selectClass').selectpicker('refresh');
    } else if (item === 'status') {
      // jQuery('.selectStatus').selectpicker('refresh');
    } else if (item === 'keySubject') {
      // jQuery('.selectKeySubject').selectpicker('refresh');
    }
  }

  addAssignmentToForm() {
    const control = this.fgAssignTeacher.controls['subjectteacher'] as FormArray;
    const subjectteacher = [...this.curClass.subjectteacher];
    const j = 0;
    // this.projectData.subjects.forEach(element => {
    this.curClass.subjects.forEach(element => {
      const index = subjectteacher.findIndex(x => x.subject && x.subject._id === element._id);
      if (index > -1) {
        if (subjectteacher[index].firstteacher
          && subjectteacher[index].firstteacher._id
          && subjectteacher[index].secondteacher
          && subjectteacher[index].secondteacher._id) {
          subjectteacher[index].firstteacher.name = subjectteacher[index].firstteacher.first_name + ' ' + subjectteacher[index].firstteacher.last_name;
          subjectteacher[index].secondteacher.name = subjectteacher[index].secondteacher.first_name + ' ' + subjectteacher[index].secondteacher.last_name;
          control.push(this.patchSubjectTeacher(subjectteacher[index].subject, subjectteacher[index].firstteacher, subjectteacher[index].secondteacher));
        } else if (subjectteacher[index].firstteacher
          && subjectteacher[index].firstteacher._id
          && !subjectteacher[index].secondteacher) {
          subjectteacher[index].firstteacher.name = subjectteacher[index].firstteacher.first_name + ' ' + subjectteacher[index].firstteacher.last_name;
          control.push(this.patchSubjectTeacher(subjectteacher[index].subject, subjectteacher[index].firstteacher, ''));
        } else {
          control.push(this.patchSubjectTeacher(subjectteacher[index].subject, '', ''));
        }
        subjectteacher.splice(index, 1);
      } else {
        control.push(this.patchSubjectTeacher(element, '', ''));
      }
    });
  }

  patchSubjectTeacher(s, t?, t_two?) {
    return this.fb.group({
      subject: s,
      teacher: t || '',
      teacher_two: t_two || ''
    });
  }

  orEmpty = (entity) => {
    return entity || '';
  }

  assignedTeachers(teach1, teach2?) {
    let x = ''; let y = '';
    if (teach1 && teach1.first_name && teach1.last_name) {
      x = this.orEmpty(teach1.first_name) + ' ' + this.orEmpty(teach1.last_name);
    }
    if (teach2 && teach2.first_name && teach2.last_name) {
      y = this.orEmpty(teach2.first_name) + ' ' + this.orEmpty(teach2.last_name);
    }

    if (x.trim() && y.trim()) {
      return x + ', ' + y;
    }
    if (x.trim()) {
      return x;
    }
    return '';
  }

  fileUploadComplete(event) {
    this.btnStatusAdd = false;
  }
  userDetailFileUploaded(data, pageType?) {
    console.log('userDetailFileUploaded >> ' + pageType);
    this.btnStatusAdd = false;
    this.pageType = pageType;
    if (pageType === 'StudentOnly') {
      let studentDob = data.file.response.studentData;
      studentDob['Date of Birth'] = studentDob['Date of Birth'];
      const str = studentDob['Date of Birth'].split('-');
      let temp = '';
      temp = str[0];
      str[0] = str[2];
      str[2] = temp;
      if (str[1] < 10)
        str[1] = '0' + str[1];
      if (str[0] < 10)
        str[0] = '0' + str[0];
      studentDob = str[2] + '-' + str[1] + '-' + str[0];
      data.file.response.studentData['Date of Birth'] = studentDob;
    }
    if (data) {
      this.xlssample = data.file.response;
      /*  this.btnTextAdd = 'Confirm';
      this.btnTextCancel = 'Cancel'; 
      this.btnTextEdit = "Edit" ;    
      this.btnStatusAdd = false;
      this.openDialogModal('modalConfirm');
      if (pageType === 'StudentOnly'){
        this.closeDialogModal('userBulkUploadModal');
      } else if (pageType === 'TeacherOnly'){
        this.closeDialogModal('teacherBulkUploadModal');
      } */
    }
  }
  verifyDataSamples() {
    this.btnTextAdd = this.translate.instant('Confirm');
    this.btnTextCancel = 'Cancel';
    this.btnTextEdit = 'Edit';
    this.btnStatusAdd = false;
    this.isImportClicked = false;
    this.openDialogModal('bulkVerifyModal');
    if (this.pageType === 'StudentOnly') {
      this.closeDialogModal('userBulkUploadModal');
    } else if (this.pageType === 'TeacherOnly') {
      this.closeDialogModal('teacherBulkUploadModal');
    }
  }
  checkAndImport(pageType) {
    /* Disable the button for additional click */
    this.btnStatusAdd = false; 
    // send request to parse the file again
    const data = {
      importedFile: this.xlssample.file,
      school_id: this.school_id
    };
    if(!this.isImportClicked){
      this.isImportClicked = true;
      this.addBulkUserOnSingleClick(pageType, data);
    }
    
    // if (this.clickTimeout) {
    //   this.setClickTimeout(() => {
    //     this.addBulkUserOnSingleClick(pageType, data);
    //   });
    // } else {
    //   this.setClickTimeout(() =>  {
    //     this.addBulkUserOnSingleClick(pageType, data)
    //   });
    // }    
  }

  addBulkUserOnSingleClick(pageType,data){
    this.schoolService.importSchoolUserData(JSON.stringify(data)).subscribe(
      (response) => {
        this.titleMessage = this.translate.instant('Import Successful');
        if (pageType === 'StudentOnly') {
          this.subTitleMessage = this.translate.instant('You have successfully added your new students');
        } else {
          this.subTitleMessage = this.translate.instant('You have successfully added your new teachers');
        }

        this.detailMessage = this.translate.instant('Their details can now be viewed in the School Management module');

        this.studentCountTxt = this.xlssample.studentCount + " " + this.translate.instant('Students') + " ";
        this.teacherCountTxt = this.xlssample.teacherCount + " " + this.translate.instant('Teachers');
        this.refreshUserList('');
        this.closeDialogModal('bulkVerifyModal');
        this.openDialogModal('successModal');
        //this.closeDialogModal('modalConfirm');
      },
      (err) => {
        console.log('ERROR: ' + err);
        this.titleMessage = this.translate.instant('Import Failed');
        this.subTitleMessage = this.translate.instant('Please check your excel document matches the template, and re-import.');
        this.closeDialogModal('modalConfirm');
        this.openDialogModal('successModal');
      },
      () => { }
    );
  }

  cancelImport() {
    this.closeDialogModal('modalConfirm');
  }

  cancelBulkImport() {
    this.closeDialogModal('bulkVerifyModal');
  }

  closeSuccessModal() {
    this.closeDialogModal('successModal');
  }
  closeModal(modal) {
    this.closeDialogModal(modal);
  }
  openDialogModal(id) {
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.show();
  }

  closeDialogModal(id) {
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.hide();
  }

  log(val) {
    console.log(val);
  }

  downloadCsv(data, type) {
    this.util.generateCSV(data, type);
  }
}
